import React, { useState } from 'react';
import SubscriptionForm from '../components/SubscriptionForm';
import Modal from '../components/Modal.js';

const MusicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
  </svg>
);
const CocktailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v13m0-13c0-2.761 2.686-5 6-5s6 2.239 6 5-2.686 5-6 5-6-2.239-6-5zm0 0c0-2.761-2.686-5-6-5s-6 2.239-6 5 2.686 5 6 5 6-2.239 6-5zM5 8h14" />
  </svg>
);
const StandUpIcon = () => (
   <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
     <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
     <path strokeLinecap="round" strokeLinejoin="round" d="M9 14h6" />
   </svg>
);
// --- Enkel Ölglas SVG Komponent ---
const BeerMugIcon = ({ className = "" }) => (
  <svg
      className={`w-8 h-8 ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fcd34d"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
  >
      <path d="M8 21V11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11V21" />
      <path d="M8 12H16" />
      <path d="M7 7C7 5.34315 8.34315 4 10 4H14C15.6569 4 17 5.34315 17 7" />
      <path d="M16 11H18C19.1046 11 20 11.8954 20 13V17C20 18.1046 19.1046 19 18 19H16" />
  </svg>
);

const EventsPage = ({ navigateTo }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const eventData = {
    afterWork: { title: "After Work", details: "Måndag - Fredag, 14:00 - 20:00", description: "Varva ner efter en lång arbetsdag! Hos oss väntar kylda drycker, utsökta smårätter och en oslagbar atmosfär. Perfekt för att möta kollegor och vänner.          🍺 Stor stark 50:-  ,  🍽️ Maträtt 149:-", image: "/images/events/awdekor.jpg" },
    karaoke: { title: "Karaoke", details: "Fredagar, 22:00 - 03:00", description: "Släpp loss din inre stjärna! Vår karaokekväll är legendarisk – ta micken, sjung ut dina favoriter och känn publikens jubel. En oförglömlig kväll garanteras!", image: "/images/events/karaoke.png" },
    dj: { title: "DJ", details: "Lördagar, 22:00 - 03:00", description: "Låt rytmen ta över! Våra DJ:s levererar pulserande beats och skapar en elektrisk stämning som får dig att dansa hela natten. Missa inte stans hetaste lördagskväll!", image: "/images/events/dj.png" },
    standUp: { title: "Stand Up", details: "Håll ögonen öppna för nästa show!", description: "Gör dig redo för en kväll fylld av skratt! Vi bjuder in landets roligaste komiker för att kittla dina skrattmuskler. Datum och artister avslöjas snart – håll utkik på instagram!", image: "/images/events/standup.jpg" }
  };

  const openModal = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  return (
     // Huvudbehållare
     <div className="min-h-screen text-gray-200 font-sans animate-slide-in-from-top animated-sky-bg overflow-hidden relative">

     {/* Behållare för himmelselement */}
     <div className="absolute inset-0 z-0">
        {/* Måne */}
        <div className="moon"></div>
        {/* Stjärnor */}
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
     </div>

     {/* Innehållsbehållare */}
     <div className="container mx-auto px-6 py-10 md:px-12 md:py-14 relative z-10">
       {/* Tillbaka-knapp */}
       <button
         onClick={() => navigateTo('home')}
         className="mb-8 inline-flex items-center text-red-400 hover:text-red-300 transition duration-150 group"
       >
         <svg className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
         Tillbaka till Hem
       </button>

       {/* Sidrubrik */}
       <h1 className="text-4xl md:text-5xl font-serif font-bold text-center text-red-500 mb-6 md:mb-8">
         Grande Events
       </h1>
       <p className="text-center text-gray-400 mb-10 md:mb-12 max-w-2xl mx-auto">
         Upplev spännande evenemang på Grande Italiensk Restaurang i Eslöv! Vi bjuder regelbundet in till underhållning som Friday Karaoke, Saturday DJ nights, After Work på vardagar och ibland även Stand Up-shower. Håll dig uppdaterad om vad som händer hos oss!
       </p>

       {/* Grid för evenemangskort - Alltid 2 kolumner */}
       <div className="grid grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16">

{/* Kort för After Work */}
         <div
           className="relative bg-gray-900 bg-opacity-70 backdrop-filter backdrop-blur-sm p-6 rounded-lg shadow-lg border border-gray-700 transform hover:scale-105 transition-transform duration-200 overflow-hidden min-h-[180px] cursor-pointer"
           onClick={() => openModal(eventData.afterWork)}
         >
            <div className="relative z-10">
               <h2 className="text-2xl font-semibold text-white mb-3"><CocktailIcon />After Work</h2>
               <p className="text-gray-400 text-lg">Måndag - Fredag</p>
               <p className="text-gray-300 text-xl font-medium">14:00 - 20:00</p>
            </div>
            <div className="clinking-beers-container absolute bottom-2 left-0 right-0 h-12 flex justify-center items-end pointer-events-none">
              <BeerMugIcon className="beer-mug beer-mug-1" />
              <BeerMugIcon className="beer-mug beer-mug-2" />
              50:- 
              <svg
  className="w-7 h-7 text-yellow-400"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  strokeWidth={1.8}
>
  <circle cx="12" cy="12" r="6" />
  <rect x="3" y="7" width="1.5" height="10" rx="0.75" />
  <rect x="19.5" y="7" width="1.5" height="10" rx="0.75" />
</svg>

              149:-
            </div>
         </div>
         {/* Kort för Karaoke */}
         <div
           className="relative bg-gray-900 bg-opacity-70 backdrop-filter backdrop-blur-sm p-6 rounded-lg shadow-lg border border-gray-700 transform hover:scale-105 transition-transform duration-200 overflow-hidden min-h-[180px] cursor-pointer"
           onClick={() => openModal(eventData.karaoke)}
         >
            <div className="relative z-10">
               <h2 className="text-2xl font-semibold text-white mb-3 flex items-center">
                   <span className="text-xl leading-none mr-2">🎤</span>
                   Karaoke
               </h2>
               <p className="text-gray-400 text-lg">Fredagar</p>
               <p className="text-gray-300 text-xl font-medium">22:00 - 03:00</p>
            </div>
            <div className="notes-container absolute bottom-0 left-0 right-0 h-20 pointer-events-none">
                <span className="music-note">♪</span>
                <span className="music-note">♫</span>
                <span className="music-note">♪</span>
                <span className="music-note">♫</span>
                <span className="music-note">♪</span>
                <span className="music-note">♫</span>
            </div>
         </div>

         {/* Kort för DJ */}
         <div
           className="relative bg-gray-900 bg-opacity-70 backdrop-filter backdrop-blur-sm p-6 rounded-lg shadow-lg border border-gray-700 transform hover:scale-105 transition-transform duration-200 overflow-hidden cursor-pointer"
           onClick={() => openModal(eventData.dj)}
         >
           <div className="relative z-10">
               <h2 className="text-2xl font-semibold text-white mb-3"><MusicIcon />DJ</h2>
               <p className="text-gray-400 text-lg">Lördagar</p>
               <p className="text-gray-300 text-xl font-medium">22:00 - 03:00</p>
           </div>
           <div className="eq-container absolute bottom-0 left-0 right-0 h-10 flex justify-center items-end gap-1 p-1 z-0">
               <span className="eq-bar"></span> <span className="eq-bar"></span> <span className="eq-bar"></span>
               <span className="eq-bar"></span> <span className="eq-bar"></span> <span className="eq-bar"></span>
           </div>
         </div>

         {/* Kort för Stand Up */}
         <div
           className="relative bg-gray-900 bg-opacity-70 backdrop-filter backdrop-blur-sm p-6 rounded-lg shadow-lg border border-gray-700 transform hover:scale-105 transition-transform duration-200 overflow-hidden cursor-pointer"
           onClick={() => openModal(eventData.standUp)}
         >
            <h2 className="text-2xl font-semibold text-white mb-3"><StandUpIcon />Stand Up</h2>
            <p className="text-gray-300 text-xl font-medium">Håll utkik!</p>
            <div className="haha-container absolute bottom-0 left-0 right-0 h-16 pointer-events-none">
               <span className="haha-text">Haha!</span> <span className="haha-text">ha!</span> <span className="haha-text">HAHA</span>
               <span className="haha-text">Hehe</span> <span className="haha-text">OMG</span> <span className="haha-text">Ha!</span>
               <span className="haha-text">LOL</span> <span className="haha-text">ha!</span> <span className="haha-text">Haha</span>
            </div>
         </div>
       </div>

        {/* Prenumerationsformulär */}
        <div className="mt-10 md:mt-16">
          <SubscriptionForm />
        </div>
     </div>

    {selectedEvent && (
      <Modal isOpen={isModalOpen} onClose={closeModal} title={selectedEvent.title} imageSrc={selectedEvent.image}>
        <p className="mb-2 text-lg text-gray-700">{selectedEvent.details}</p>
        <p className="text-md text-gray-700">{selectedEvent.description}</p>
      </Modal>
    )}

     {/* Inline CSS för animationer och himmelselement */}
     <style>{`
       /* Befintliga animationer och stilar */
       @keyframes slideInFromTop {
         from {
           opacity: 0;
           transform: translateY(-100%);
         }
         to {
           opacity: 1;
           transform: translateY(0);
         }
       }
       .animate-slide-in-from-top { animation: slideInFromTop 0.5s ease-out forwards; }
       /* Behöll fadeIn ifall den används någon annanstans, annars kan den tas bort */
       @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
       .animate-fade-in { animation: fadeIn 0.5s ease-out forwards; }
       @keyframes skyShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
       .animated-sky-bg { background: linear-gradient(-45deg, #000000, #0a0a0a, #1a1a2a, #202030, #0a0a0a, #000000); background-size: 600% 600%; animation: skyShift 25s ease infinite; }
       .moon { position: absolute; top: 10%; right: 15%; width: 60px; height: 60px; background-color: #e2e8f0; border-radius: 50%; box-shadow: 0 0 15px rgba(226, 232, 240, 0.4); opacity: 0.7; }
       @keyframes blink { 0%, 100% { opacity: 0.2; } 50% { opacity: 0.8; } }
       .stars, .stars2, .stars3 { position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 1px; height: 1px; background: transparent; animation: blink 2s infinite alternate ease-in-out; }
       .stars { /* ... box-shadow ... */ box-shadow: 50px 100px #FFF, 200px 50px #FFF, 350px 150px #FFF, 100px 300px #FFF, 400px 250px #FFF, 600px 80px #FFF, 700px 350px #FFF, 900px 120px #FFF, 1100px 280px #FFF, 1300px 180px #FFF, 1500px 320px #FFF, 550px 450px #FFF, 800px 500px #FFF, 1000px 400px #FFF, 1200px 550px #FFF, 1400px 480px #FFF, 1600px 220px #FFF, 1700px 400px #FFF, 1850px 100px #FFF, 1950px 500px #FFF, 50px 600px #FFF, 250px 700px #FFF, 450px 650px #FFF, 650px 750px #FFF, 850px 600px #FFF, 1050px 720px #FFF, 1250px 680px #FFF, 1450px 780px #FFF, 1650px 630px #FFF, 1800px 700px #FFF, 1900px 600px #FFF, 300px 850px #FFF; }
       .stars2 { /* ... box-shadow ... */ box-shadow: 150px 200px #FFF, 450px 100px #FFF, 750px 250px #FFF, 1050px 50px #FFF, 1250px 300px #FFF, 1450px 150px #FFF, 250px 400px #FFF, 850px 380px #FFF, 1150px 420px #FFF, 1550px 280px #FFF, 1750px 520px #FFF, 1950px 350px #FFF, 50px 500px #FFF, 350px 550px #FFF, 650px 480px #FFF, 950px 580px #FFF, 1350px 490px #FFF, 1680px 390px #FFF, 1880px 530px #FFF, 100px 700px #FFF, 300px 800px #FFF, 500px 680px #FFF, 700px 780px #FFF, 900px 650px #FFF, 1100px 750px #FFF, 1300px 620px #FFF, 1500px 720px #FFF, 1700px 600px #FFF, 1900px 750px #FFF, 400px 900px #FFF, 800px 850px #FFF, 1200px 820px #FFF; animation-duration: 3s; }
       .stars3 { /* ... box-shadow ... */ box-shadow: 250px 150px #FFF, 550px 300px #FFF, 850px 100px #FFF, 1150px 250px #FFF, 1450px 50px #FFF, 50px 450px #FFF, 350px 380px #FFF, 950px 410px #FFF, 1350px 390px #FFF, 1650px 190px #FFF, 1850px 430px #FFF, 1980px 200px #FFF, 150px 580px #FFF, 450px 620px #FFF, 750px 530px #FFF, 1050px 670px #FFF, 1250px 590px #FFF, 1550px 640px #FFF, 1750px 500px #FFF, 1950px 680px #FFF, 200px 750px #FFF, 500px 820px #FFF, 800px 720px #FFF, 1000px 880px #FFF, 1300px 770px #FFF, 1600px 830px #FFF, 1800px 780px #FFF, 1950px 850px #FFF, 600px 950px #FFF, 1400px 920px #FFF, 900px 980px #FFF, 1700px 900px #FFF; animation-duration: 2.5s; }
       @keyframes equalizer { 0%, 100% { transform: scaleY(0.1); } 50% { transform: scaleY(1); } }
       .eq-bar { display: inline-block; width: 4px; height: 100%; background-color: #ef4444; transform-origin: bottom; animation: equalizer ease-in-out infinite alternate; }
       .eq-bar:nth-child(1) { animation-duration: 0.4s; } .eq-bar:nth-child(2) { animation-duration: 0.6s; } .eq-bar:nth-child(3) { animation-duration: 0.3s; }
       .eq-bar:nth-child(4) { animation-duration: 0.5s; } .eq-bar:nth-child(5) { animation-duration: 0.7s; } .eq-bar:nth-child(6) { animation-duration: 0.4s; }
       .backdrop-filter { backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }

       /* --- KORT-ANIMATIONER --- */
           /* After Work Kort: Klirrande ölglas */
        @keyframes clinkBeer { 0% { transform: translateX(0) rotate(0deg); } 25% { transform: translateX(-5px) rotate(-8deg); } 50% { transform: translateX(5px) rotate(8deg) scale(1.05); } 75% { transform: translateX(-3px) rotate(-5deg); } 100% { transform: translateX(0) rotate(0deg); } }
        .beer-mug { transition: transform 0.2s ease-out; }
        .beer-mug-1 { animation: clinkBeer 1.5s ease-in-out 2s infinite; margin-right: -10px; /* Lite överlappning */ }
        .beer-mug-2 { animation: clinkBeer 1.5s ease-in-out 2.1s infinite reverse; /* Kör omvänt och med liten fördröjning */ }
        .clinking-beers-container:hover .beer-mug-1 { transform: translateX(-8px) rotate(-12deg) scale(1.1); }
        .clinking-beers-container:hover .beer-mug-2 { transform: translateX(8px) rotate(12deg) scale(1.1); }



       /* Karaoke: Flytande noter */
       @keyframes floatUp {
         0% { transform: translateY(0) translateX(0); opacity: 0; }
         50% { opacity: 0.8; }
         100% { transform: translateY(-45px) translateX(10px); opacity: 0; } /* Flyter uppåt och lite åt höger */
       }
       .music-note {
         position: absolute;
         bottom: 0px; /* Startar längst ner i containern */
         font-size: 1rem; /* Notstorlek */
         color: #f1f5f9; /* Ljusgrå/vit */
         opacity: 0;
         animation-name: floatUp;
         animation-timing-function: linear;
         animation-iteration-count: infinite;
       }
       /* Individuell position och fördröjning för noter */
       .music-note:nth-child(1) { left: 50%; animation-duration: 3.5s; animation-delay: 2.1s; }
       .music-note:nth-child(2) { left: 55%; animation-duration: 4.0s; animation-delay: 1.0s; font-size: 0.8rem; color: #f87171; } /* Röd */
       .music-note:nth-child(3) { left: 60%; animation-duration: 3.2s; animation-delay: 2.5s; }
       .music-note:nth-child(4) { left: 69%; animation-duration: 4.5s; animation-delay: 1.8s; font-size: 0.9rem; }
       .music-note:nth-child(5) { left: 80%; animation-duration: 3.8s; animation-delay: 2.5s; color: #f87171; } /* Röd */
       .music-note:nth-child(6) { left: 50%; animation-duration: 4.2s; animation-delay: 2.5s; font-size: 1.1rem; }

       /* Stand Up: Haha Text Animation */
       @keyframes hahaJump { 0% { transform: translateY(0) scale(0.8); opacity: 0; } 20%, 60% { transform: translateY(-25px) scale(1); opacity: 1; } 100% { transform: translateY(-40px) scale(0.8); opacity: 0; } }
       .haha-text { position: absolute; bottom: 5px; font-weight: bold; font-style: italic; color: #cbd5e1; opacity: 0; animation: hahaJump ease-out infinite; }
       /* Individuella stilar för haha-texter */
       .haha-text:nth-child(1) { left: 85%; font-size: 0.8rem; animation-duration: 2.1s; animation-delay: 3.9s; }
       .haha-text:nth-child(2) { left: 80%; font-size: 0.7rem; color: #f87171; animation-duration: 1.7s; animation-delay: 0.8s; }
       .haha-text:nth-child(3) { left: 65%; font-size: 0.9rem; animation-duration: 2.4s; animation-delay: 1.4s; }
       .haha-text:nth-child(4) { left: 60%; font-size: 0.75rem; color: #facc15; animation-duration: 1.9s; animation-delay: 1.2s; }
       .haha-text:nth-child(5) { left: 50%; font-size: 0.8rem; animation-duration: 2.0s; animation-delay: 1.8s; }
       .haha-text:nth-child(6) { left: 66%; font-size: 0.9rem; color: #f87171; animation-duration: 1.6s; animation-delay: 2.2s; }
       .haha-text:nth-child(7) { left: 55%; font-size: 0.7rem; animation-duration: 2.3s; animation-delay: 2.6s; }
       .haha-text:nth-child(8) { left: 90%; font-size: 0.8rem; color: #facc15; animation-duration: 1.8s; animation-delay: 2.5s; }
       .haha-text:nth-child(9) { left: 77%; font-size: 0.75rem; animation-duration: 2.5s; animation-delay: 1.1s; }
     `} </style>
   </div>
  );
};

export default EventsPage;